var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    title: "Star",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.11164 1.27215C7.51461 0.642683 8.48539 0.642683 8.88836 1.27215L10.845 4.32857C10.9898 4.55471 11.226 4.71598 11.4995 4.77553L15.1963 5.5804C15.9577 5.74617 16.2577 6.61408 15.7454 7.16888L13.2578 9.86272C13.0738 10.062 12.9836 10.323 13.0078 10.5859L13.3359 14.1398C13.4035 14.8717 12.6181 15.4081 11.8985 15.1215L8.40446 13.73C8.14594 13.627 7.85406 13.627 7.59554 13.73L4.10147 15.1215C3.38187 15.4081 2.5965 14.8717 2.66407 14.1398L2.99216 10.5859C3.01644 10.323 2.92624 10.062 2.7422 9.86272L0.254642 7.16887C-0.257664 6.61408 0.0423232 5.74617 0.803681 5.5804L4.50053 4.77553C4.77405 4.71598 5.01019 4.55471 5.15495 4.32857L7.11164 1.27215Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.9e069b568aaabebfd30f9086436c6210.svg";
export { ForwardRef as ReactComponent };